import React from 'react';
import './InfoTooltip.css';

// Pure CSS :hover/:focus reveal — no JS positioning needed, which also
// means it can never fall victim to the "transformed ancestor becomes the
// containing block for position:fixed" bug the old click-driven version
// hit (see the tenant-card hover fix). Same public API (just `text`) so
// every existing call site is unaffected by this rewrite.
//
// This is the app's "expand for more explanation" affordance at the
// column-header/settings-row-label level — always available, since there's
// no separate Forklaret/Teknisk mode to gate it behind any more.
export default function InfoTooltip({ text }) {
  return (
    <span className="info-tip" tabIndex={0}>
      i
      <span className="info-tip__bubble">{text}</span>
    </span>
  );
}
